import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { TailSpin } from 'react-loader-spinner';
import useSWR from 'swr';
import './App.scss';
import desallLogo from './assets/desall_logo.png';
//Components

import { endBusyMode, fetchMenus, fetchTags, setCounters, setNavLinkActive, setStrapiCommunity } from './store/DslStore';

import Container from './Container';
import ScrollToTop from './ScrollToTop';
import axiosHelper from './helpers/axiosHelper';
import { useAuth } from './context/AuthContext';
import LogoAnimation from './components/LogoAnimation/LogoAnimation';

const App: React.FC = () => {
  const { data, error, isLoading } = useSWR('menus', axiosHelper.strapiFetcher);
  const { busyAuthenticating } = useAuth();
  const [menusFetched, setMenusFetched] = useState(false);

  const getstrapiCommunity = async () => {
    await axiosHelper.fetchStrapiCommunity().then((response) => {
      setStrapiCommunity(response.data.attributes.content);
    });
  };
  useEffect(() => {
    // console.log(data);
  }, [data]);
  useEffect(() => {
    // console.log(error);
  }, [error]);
  useEffect(() => {
    // console.log(isLoading);
  }, [isLoading]);

  useEffect(() => {
    // axiosHelper.tokLogin().then(() => {
    // fetchMenus.run().then(async () => {
    fetchMenus.run().then(() => {
      setMenusFetched(true);
      getstrapiCommunity();
      // await axiosHelper.fetchStrapiCommunity().then((response) => {
      //   // console.log(response.data.attributes.DynamicCommunity);
      //   setStrapiCommunity(response.data.attributes.DynamicCommunity);
      // });
    });
    // setCategories.run();
    setCounters.run();
    Promise.all([
      // fetchContest.run(),
      // fetchCoCreationContest.run(),
      fetchTags.run(),
    ]).then((values) => {
      // console.log(' fetchAll');
      // console.log(values);
      endBusyMode();
      setNavLinkActive({ text: 'Home', path: '/', id: 0 });
    });
    // });
  }, []);

  return (
    <>
      {menusFetched && !busyAuthenticating && (
        <Router>
          <ScrollToTop />
          <Container />
        </Router>
      )}
      {(!menusFetched || busyAuthenticating) && (
        <div className="bg-light-gray">
          <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <LogoAnimation />
          </div>
        </div>
      )}
    </>
  );
};

export default App;
